module.exports = __webpack_public_path__ + "static/media/lock-status-unknown.132085af.svg";